import PropTypes from "prop-types";

export default class Common {
    constructor() {
        window.onunload = function () {};
        this.storageAvailable = this.getStorageAvailable();
        this.setLastUrl();
    }

    setLastUrl() {
        if (!this.storageAvailable) return;
        this.lastUrl = localStorage.getItem("lastUrl");
        localStorage.setItem("lastUrl", window.location.pathname);
    }

    getStorageAvailable() {
        try {
            let x = "__storage_test__";
            localStorage.setItem(x, x);
            localStorage.removeItem(x);
            return true;
        } catch (e) {
            return (
                e instanceof DOMException &&
                // everything except Firefox
                (e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === "QuotaExceededError" ||
                    // Firefox
                    e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage.length !== 0
            );
        }
    }

    getURLParams() {
        let { search } = window.location;
        const hashes = search.slice(search.indexOf("?") + 1).split("&");
        return hashes.reduce((params, hash) => {
            const split = hash.indexOf("=");

            if (split < 0) {
                return Object.assign(params, {
                    [hash]: null,
                });
            }

            const key = hash.slice(0, split);
            const val = hash.slice(split + 1);

            return Object.assign(params, { [key]: decodeURIComponent(val) });
        }, {});
    }
}

export const getRandomString = (length) => {
    if (!length) length = 16;
    let result = "";
    let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
};

export const pottsalatConfigPropType = {
    url: PropTypes.string,
    googleMapsKey: PropTypes.string,
    baseBowlId: PropTypes.number,
    baseSaladId: PropTypes.number,
    iconPath: PropTypes.string,
};
